import { store } from 'store/reducers'
import { Format } from './Dates'

export const getHolidays = dates => {
  const {
    resources: { holidays }
  } = store.getState()
  if (!Array.isArray(dates)) dates = [dates]
  return holidays.filter(({ date: holidayDate }) => dates.some(date => holidayDate === Format(date, { outFormat: 'date' })))
}
